<template>
    <div>
        <div class="footer-menu" :style="skin.header_desktop.nav_bar" id="main_sidebar" style="z-index: 99;">
            <div class="c">
                <div v-if="skin.casinoN" class="optiones" @click="change_view('Casino')" :style="getDivStyle('Casino')  +';order:'+ this.skin.order[0] +';'">
                    <svg :style="getSvgStyle('Casino')" width="20" heigth="20" viewBox="0 0 64 64" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.265 47.726.21 14.603a3.574 3.574 0 0 1 2.108-4.553l.024-.007 19.282-7.015a3.55 3.55 0 0 1 4.553 2.082l.008.024.694 1.92L12.69 46.073a8.9 8.9 0 0 0-.418 1.598l-.008.056ZM63.79 15.511 48.002 58.93a3.529 3.529 0 0 1-4.558 2.1l.024.009-21.948-8.001a3.58 3.58 0 0 1-2.124-4.585l-.008.024 15.787-43.39a3.555 3.555 0 0 1 4.559-2.126l-.024-.008 21.948 8a3.58 3.58 0 0 1 2.124 4.585l.008-.024v-.002ZM50.457 32.685l-1.386-3.254a1.789 1.789 0 0 0-2.333-.956l.012-.004-2.666 1.174a1.787 1.787 0 0 1-2.316-.948l-.004-.012-1.146-2.667a1.764 1.764 0 0 0-2.332-.93l.012-.004-3.28 1.386a1.738 1.738 0 0 0-.929 2.33l-.004-.01 3.92 9.255a1.816 1.816 0 0 0 2.359.928l-.012.005 9.227-3.947a1.737 1.737 0 0 0 .794-2.356l.004.01h.08Z">
                        </path>
                    </svg>
                    <span> {{ translate("casino1") }} </span>
                </div>
                <div v-if="skin.prematch != null ? skin.prematch : true" class="optiones" @click="change_view('Sports')"
                    :style="getDivStyle('Sports') +';order:'+ this.skin.order[1] +';'">
                    <svg :style="getSvgStyle('Sports')" width="20" heigth="20" viewBox="0 0 96 96" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path clip-rule="evenodd"
                            d="M14.287 13.917c16.599 6.854 30.869 15.965 43.231 27.143l-.001.002.126.11-.125-.112C64.262 31 65.501 17.31 60.63 1.865 56.773.739 52.34.092 47.758.092c-13.046 0-24.87 5.249-33.47 13.748v.077Zm79.997 46.514a46.803 46.803 0 0 1-7.907 15.996v-.003c-2.275-3.87-4.709-7.622-7.185-11.295l-.137.08c4.463-2.823 9.63-4.63 15.307-5.11l-.078.332ZM80.986 82.734c-4.75 4.553-10.46 8.116-17.124 10.458h-.003l.006-.108a38.977 38.977 0 0 1 9.137-22.842l-.281-.41c2.838 3.924 5.478 8.005 8.265 12.902Zm0 0 .016-.014-.015.015ZM12.017 64.772a83.99 83.99 0 0 0 9.697.599h.003l-.117-.006c.832.039 1.674.06 2.518.06 12.98 0 24.848-4.766 33.883-12.589a132.455 132.455 0 0 1 9.859 11.137 47.738 47.738 0 0 0-11.975 31.216l.284-.042c-2.68.49-5.44.751-8.269.76-21.022-.012-38.88-13.566-45.416-32.75 3.102.685 6.287 1.224 9.931 1.654l-.398-.039Zm-9.533-1.614c-.226-.05-.45-.1-.675-.152l.667.129.008.023Zm65.376.815.045-.051-.045.05ZM58 52.836l-.009-.009.01.01Zm-5.59-5.706A140.354 140.354 0 0 0 9.776 20.677l-.952-.332C3.305 28.021 0 37.61 0 47.97v.038c.018 2.3.192 4.539.512 6.733l-.033-.266c3.542.97 7.889 1.823 12.325 2.386l.488.05c16.526 1.797 30.138-1.637 39.12-9.78Zm21.58 11.182a149.73 149.73 0 0 0-10.601-11.7c7.864-10.897 10.059-25.19 6.466-41.155l.267.126C85.46 13.537 95.953 29.542 96 48.007c0 .604-.048 1.247-.097 1.904-.051.688-.104 1.393-.104 2.087h-.042c-8.002.159-15.445 2.596-21.552 6.586l-.215-.272Zm-10.601-11.7-.003-.003.003.003Z">
                        </path>
                    </svg>
                    <span> {{ translate("sports") }} </span>
                </div>
                <div class="optiones" @click="change_view('Home')" style="position: relative;" :style="'order:'+ this.skin.order[2] +';'">
                    <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                        :style="getSvgStyle('Home')" style="top:-15px;max-width: 100%;position: absolute;z-index: 10;">
                    <svg :style="getSvgStyle('Home')" width="20" heigth="20" viewBox="0 0 16 16" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path clip-rule="evenodd"
                            d="M8 0L0 6V8H1V15H4V10H7V15H15V8H16V6L14 4.5V1H11V2.25L8 0ZM9 10H12V13H9V10Z"></path>
                    </svg>
                    <span> {{ translate("inicio") }} </span>
                </div>
                <div v-if="skin.casino_live" class="optiones" @click="change_view('CasinoLive')"
                    :style="getDivStyle('CasinoLive')+';order:'+ this.skin.order[3] +';'">
                    <svg :style="getSvgStyle('CasinoLive')" width="20" heigth="20" x="0px" y="0px" viewBox="0 0 24 24"
                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path d="M21,12c0,2.481-1.009,4.731-2.639,6.361l1.414,1.414C21.766,17.783,23,15.033,23,12s-1.234-5.783-3.225-7.775l-1.414,1.414
                            C19.991,7.269,21,9.519,21,12z"></path>
                            <path d="M3,12c0-2.481,1.009-4.731,2.639-6.361L4.225,4.225C2.234,6.217,1,8.967,1,12s1.234,5.783,3.225,7.775l1.414-1.414
                            C4.009,16.731,3,14.481,3,12z"></path>
                            <path d="M16.947,7.053l-1.414,1.414C16.439,9.372,17,10.622,17,12s-0.561,2.628-1.466,3.534l1.414,1.414
                            C18.215,15.68,19,13.93,19,12S18.215,8.32,16.947,7.053z"></path>
                            <path d="M7.053,16.947l1.414-1.414C7.561,14.628,7,13.378,7,12s0.561-2.628,1.466-3.534L7.053,7.053C5.785,8.32,5,10.07,5,12
                            S5.785,15.68,7.053,16.947z"></path>
                        </g>
                        <g>
                            <circle cx="12" cy="12" r="3"></circle>
                        </g>
                    </svg>
                    <span> {{ translate("live Casino") }} </span>
                </div>
                <div v-if="skin.crazzywin" class="optiones" @click="change_view('CrazzyWin')"
                    :style="getDivStyle('CrazzyWin') +';order:'+ this.skin.order[4] +';'">
                    <i :style="getSvgStyle('CrazzyWin')" class="fa-solid fa-rocket fa-lg" style="color: #ffffff;"></i>
                    <span> {{ translate("Crash") }} </span>
                </div>
                <div v-if="skin.hipicas" class="optiones" @click="change_view('Hipicas')"
                    :style="getDivStyle('Hipicas')+';order:'+ this.skin.order[5] +';'">
                    <i :style="getSvgStyle('Hipicas')" class="fa-solid fa-horse fa-lg" style="color: #ffffff;"></i>
                    <span> {{ translate("horse_riding") }} </span>
                </div>
                <div v-if="skin.poker" class="optiones" @click="change_view('Poker')" :style="getDivStyle('Poker')+';order:'+ this.skin.order[6] +';'">
                    <i :style="getSvgStyle('Poker')" class="fa-solid fa-dice fa-lg" style="color: #ffffff;"></i>
                    <span> {{ translate("POKER") }} </span>
                </div>
                <div v-if="skin.bingo" class="optiones" @click="change_view('Bingo')" :style="getDivStyle('Bingo')">
                    <i :style="getSvgStyle('Bingo')+';order:'+ this.skin.order[7] +';'" class="fa-solid fa-gamepad fa-lg" style="color: #ffffff;"></i>
                    <span> {{ translate("Bingo") }} </span>
                </div>
            </div>
        </div>
        <div class="modal-container1" v-if="isLoginVisible"
            :style="'margin-top:' + contentHeight + '; height:' + (this.screen_width < 767 ? (this.screen_heigth - 120) + 'px;' : (this.screen_heigth) + 'px;')">
            <login v-if="isLoginVisible" @close-login="isLoginVisible = false" v-bind:skin="skin"
                v-bind:language="language" v-bind:translation="translation"></login>
        </div>
    </div>
</template>

<script>
import router from "../../../router";
import login from "./login.vue";
export default {
    name: "Header",
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            screen_width: 0,
            screen_heigth: 0,
            isLoginVisible: false,
        }
    },
    components: {
        login
    },
    methods: {
        sizeControl() {
            this.screen_width = window.innerWidth;
            this.screen_heigth = window.innerHeight;
        },
        change_view(view) {
            if ((view == "CasinoLive" || view == "Casino" || view == "Hipicas" || view == "Bingo" || view == "Poker" || view == "CrazzyWin"|| view =="Home") &&  this.user.token == '') {
                this.isLoginVisible = true;
            }
            else {
                router.push({ name: view }).catch(() => { })

            }
        },
        getDivStyle(view) {
            if (this.$route.name.toLowerCase() === view.toLowerCase()) {
                return {
                    boxShadow: `inset 0 4px 0 0 ${this.skin.main_active_2}`,
                    transition: 'box-shadow .3s ease',
                };
            } else {
                return {};
            }
        },
        getSvgStyle(view) {
            if (this.$route.name.toLowerCase() === view.toLowerCase()) {
                return {
                    animation: `latido 1.5s ease-in-out`,
                    '--animation-color': `${this.skin.main_active_2} !important`,
                    transition: 'border .3s ease',
                    transformOrigin: 'center',
                    color: `${this.skin.main_active_2}`
                };
            } else {
                return {};
            }
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        }
    },
    computed: {
        contentHeight() {
            return this.$store.getters["getHeaderHeight"] + "px";
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        }
    },
    mounted(){
        window.addEventListener('resize', () => { this.sizeControl(); });
    }
}

</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');

@keyframes latido {
    0% {
        transform: scale(1);
        filter: brightness(1) drop-shadow(0 0 0px var(--animation-color));
    }

    50% {
        transform: scale(1.2);
        filter: brightness(1.6) drop-shadow(0 0 15px var(--animation-color));
    }

    100% {
        transform: scale(1);
        filter: brightness(1) drop-shadow(0 0 0px var(--animation-color));
    }
}
.modal-container1 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000719;
    /* Fondo semitransparente */
    display: flex;
    justify-content: center;
        align-items: flex-start;
    padding-top: 50px;
}

.footer-menu {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    color: white;
    font-family: 'Arial', sans-serif;
    border-top: 1px solid #333;
}

.c {
    width: 100%;
    height: 100%;
    min-width: 30px;
    display: flex;
    gap: 20px;
    justify-content: space-around;
    align-content: center;
}

.optiones {
    position: relative;
    font-family: "Open Sans";
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-variation-settings: "wdth" 100;
    font-size: 13px;
    width: 80px;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
}
</style>